import * as React from 'react';
const SvgCopy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.662 1.35a2.913 2.913 0 0 0-2.904 2.689.15.15 0 0 0 .15.161H6.19a.15.15 0 0 0 .149-.129 1.34 1.34 0 0 1 1.323-1.146h6.8a2.613 2.613 0 0 1 2.613 2.612v6.8c0 .674-.498 1.232-1.146 1.324a.15.15 0 0 0-.129.149v1.282a.15.15 0 0 0 .161.15 2.913 2.913 0 0 0 2.69-2.905v-6.8a4.187 4.187 0 0 0-4.188-4.187z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.263 4.75A2.913 2.913 0 0 0 1.35 7.662v8.076a2.913 2.913 0 0 0 2.913 2.912h8.075a2.913 2.913 0 0 0 2.912-2.912V7.662a2.913 2.913 0 0 0-2.912-2.912zM2.925 7.662c0-.738.599-1.337 1.338-1.337h8.075c.738 0 1.337.599 1.337 1.337v8.076c0 .738-.599 1.337-1.337 1.337H4.263a1.337 1.337 0 0 1-1.338-1.337z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCopy;
